<template>
  <div></div>
</template>

<script>
import moment from 'moment';
import Cookies from 'js-cookie';
import apis from '@/utils/apis';

export default {
  data() {
    return {
      code: '',
      state: '',
    };
  },
  mounted() {
    this.code = this.$getQueryString('code');
    this.state = this.$getQueryString('state');
    this.init();
  },
  methods: {
    init: function () {
      if (!this.code || !this.state) {
        return;
      }
      if (this.state === 'login') {
        this.wechatLogin();
      }
      if (this.state === 'bind') {
        this.bindWechat();
      }
    },
    // 扫码登录
    wechatLogin: function () {
      this.$postJSON(`${apis.WechatLogin}/${this.code}`).then((res) => {
        if (res.code === 0) {
          if (!res.data.isNeedBinding) {
            const timeOut = Number(moment(Date.now()).format('X')) + res.data.token.expiresIn;
            Cookies.set('token', res.data.token.accessToken, { path: '/' });
            Cookies.set('tokenTimeOut', timeOut, { path: '/' });
            Cookies.set('nonMetric', res.data.nonMetric, { path: '/' });
            this.$store.commit('USERINFO', res.data.userInfo);
            this.$store.commit('TIMEZONEID', res.data.timeZoneId);
            this.$store.commit('TIMEZONECOUNT', res.data.timeZoneCount);
            this.$store.commit('DATEFORMAT', res.data.dateFormat);
            this.$store.commit('ISTIME24H', res.data.isTime24h);
            this.$store.commit('TIMEZONESHORT', res.data.timeZoneShort);
            this.jumpHome(() => {});
          }
        } else if (res.code === 408) {
          this.jump('/bindaccount', { userAuthId: res.data }, true);
        }
      });
    },
    // 扫码绑定
    bindWechat: function () {
      this.$postJSON(apis.ThirdPartyBind, { code: this.code, provider: 'weixin' }).then((res) => {
        if (res.code === 0) {
          this.jump('/userset', { tab: 'bind' }, true);
        }
      });
    },

    // 获取首页
    jumpHome(cb) {
      this.$getJSON(apis.AppList, { appType: 2 })
        .then((res) => {
          cb();
          const appList = res.data;
          if (appList && appList.length) {
            const appId = appList[0]['appId'];
            this.initAppMenu(appId);
            return;
          }
          this.signout();
        })
        .catch(() => {
          cb();
        });
    },
    // 应用首菜单
    initAppMenu: function (appId) {
      this.$getJSON(`${apis.App}/${appId}`).then((res) => {
        const menu = res.data || [];
        const firstMenu = menu[0] || {};
        const firstMenuItem = firstMenu.children && firstMenu.children[0] ? firstMenu.children[0] : firstMenu;
        this.jump(firstMenuItem.loadRes);
      });
    },
    // 退出登录
    signout: function () {
      this.$postJSON(apis.Logout).finally(() => {
        this.$store.commit('LOGINOUT');
        Cookies.remove('loginName', { path: '/' });
        Cookies.remove('token', { path: '/' });
        Cookies.remove('nonMetric', { path: '/' });
        Cookies.remove('tokenTimeOut', { path: '/' });
      });
    },
  }
};
</script>

<style lang="scss">
</style>
